// extracted by mini-css-extract-plugin
export default {"project":"project_project__SuYOY","projectContent":"project_projectContent__D45eR"};